import { decodeHtmlEntities } from "./HtmlEntities";

// Plain-text preview of a Markdown message (conversation list, quotes).
export function removeMarkdown(inputString: string): string {
  try {
    // Remove AI source annotations ([^1|title|url]) entirely — these are
    // citation markers, not prose, and must never leak into the preview.
    // An optional leading space is consumed so "glance [^1|…]. " collapses
    // cleanly to "glance. " rather than leaving an orphaned space.
    let plainText = inputString.replace(/ ?\[\^\d+\|[^\]]*\]/g, "");

    // Remove Markdown links, keeping the link text only, including http, https, mailto, and gleap://bot
    const linkRegex = /\[([^\]]+)\]\(((https?|mailto|gleap):\/\/[^\)]+)\)/g;
    plainText = plainText.replace(linkRegex, "$1");

    // Strip heading markers (#, ##, ### …) at the start of a line, keeping the text only
    plainText = plainText.replace(/^[ \t]*#{1,6}[ \t]*/gm, "");

    // Strip blockquote markers (>) at the start of a line
    plainText = plainText.replace(/^[ \t]*>[ \t]?/gm, "");

    // Remove bold text markers (**text** or __text__), keeping the text only
    const boldRegex = /(\*\*|__)(.*?)\1/g;
    plainText = plainText.replace(boldRegex, "$2");

    // Remove italic text markers (*text* or _text_), keeping the text only
    const italicRegex = /(\*|_)(.*?)\1/g;
    plainText = plainText.replace(italicRegex, "$2");

    // Strip inline code backticks, keeping the code text only
    plainText = plainText.replace(/`([^`]+)`/g, "$1");

    // The server stores message text HTML-escaped ("Look &amp; feel"); the
    // preview renders as a React text node, so decode every entity once.
    plainText = decodeHtmlEntities(plainText);

    // Collapse whitespace left behind by removed markers
    plainText = plainText.replace(/[ \t]{2,}/g, " ");

    return plainText;
  } catch (e) {
    // Return the input string unchanged in case of an error
    return inputString;
  }
}
